import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { MenuItem, TextField } from '@mui/material'

import { UserLanguage } from '../../../../../features/account/types/User'

const previewLanguages: UserLanguage[] = ['en', 'zh', 'ja']

type PreviewLanguageSelectProps = {
  value: UserLanguage
  onChange: (language: UserLanguage) => void
}

export const PreviewLanguageSelect: FC<PreviewLanguageSelectProps> = ({ value, onChange }) => {
  const { t } = useTranslation()
  return (
    <TextField
      select
      size="small"
      label={t('internal-analysts:review_preview_language')}
      value={value}
      onChange={(event) => onChange(event.target.value as UserLanguage)}
      sx={{ minWidth: 160 }}
    >
      {previewLanguages.map((language) => (
        <MenuItem key={language} value={language}>
          {t(`internal-common:${language}`)}
        </MenuItem>
      ))}
    </TextField>
  )
}
